export const convertingDateToUTC = (date) => {
    const localDate = new Date(date);
    const timeZoneOffsetInMinutes = localDate.getTimezoneOffset();
    localDate.setMinutes(localDate.getMinutes() - timeZoneOffsetInMinutes);
    const isoDateString = localDate.toISOString();
    return isoDateString;
};
